<template>
    <div>
        <Row>
        <i-col span="22">
    <Form ref="formInline" label-position="right" :label-width="60" :model="formInline"  inline>
        <FormItem prop="user" label="关键字">
            <i-input type="text" v-model="formInline.keywords" placeholder="关键字"></i-input>
        </FormItem>
         <FormItem>
            <Button type="primary" @click="mockTableData" title="adminsearch">查询</Button>
        </FormItem>
         </Form>
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add" v-if="privilegesbtn('/company_admin/create')">新增</Button>  
        </i-col>
    </Row>
       
   
        <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
            </div>
        </div>
    </div>
</template>
<script>
import {
  company_adminlist,
  deletecompany_admin,
  updatecompany_admin
} from "../../api/companyapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte: privilegesbtn("/company_admin/update"),
      isdelete: privilegesbtn("/company_admin/delete"),
      // isadminlist: privilegesbtn("/company_admin/index"),
      company_id: "",
      formInline: {
        keywords: ""
      },
      tableColumns: [
        {
          title: "用户名",
          key: "username",
          align: "center",
          width: 100,
          fixed: "left"
        },
        {
          title: "集团名称",
          key: "company_name",
            width: 100,
          align: "center"
        },
        {
          title: "真实姓名",
          key: "realname",
          width: 100,
          align: "center"
        },

        {
          title: "email",
          align: "center",
          width: 150,
          key: "email"
        },
        {
          title: "手机号码",
          align: "center",
          width: 120,
          key: "mobile"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createtime",
          width: 200
        },
        {
          title: "角色",
          align: "center",
          width: 100,
          key: "role",
          render: (h, params) => {
            var list = params.row.role;
            let rolename = "";
            list.forEach(element => {
              rolename += element.name + ",";
            });
            return h("span", rolename);
          }
        },
        {
          title: "上次登陆时间",
          align: "center",
          key: "logintime",
          width: 200
        },
        {
          title: "锁定状态",
          key: "action",
          align: "center",
          width: 100,
          render: (h, params) => {
            var islock = params.row.islock == 0 ? "未锁定" : "锁定";
            var _this = this;
            return h(
              "i-switch",
              {
                props: {
                  value: params.row.islock === 1,
                  size: "large"
                },
                on: {
                  "on-change": value => {
                    _this.adminlock(params.row);
                  }
                }
              },
              [
                h("span", {
                  slot: "open",
                  domProps: {
                    innerHTML: "锁定"
                  }
                }),
                h("span", {
                  slot: "close",
                  domProps: {
                    innerHTML: "未锁定"
                  }
                })
              ]
            );
          }
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isupdte
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.login(params.row);
                    }
                  }
                },
                "登录集团后台"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isupdte
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: !this.isdelete
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn: privilegesbtn,
    mockTableData() {
      let para = {
        page: this.page,
        company_id: this.company_id,
        pagesize: this.pagesize,
        keywords: this.formInline.keywords
      };
      this.$Loading.start();
      company_adminlist(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
          this.tableData.forEach(item=>{
            item.company_name=this.company_name
        })
        
      });
    },
    adminlock(data) {
      let para = {
        company_id: this.company_id,
        id: data.id,
        realname: data.realname,
        email: data.email,
        mobile: data.mobile,
        islock: data.islock ? 0 : 1
      };

      this.$Loading.start();
      updatecompany_admin(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
        } else {
          this.changePage(this.page);
          this.$Message.error(data.message);
        }
      });
    },
    show(param) {
      if (param) {
        var data = param;
        data.company_id = this.company_id;
        data.role = JSON.stringify(data.role);
        this.$router.push({
          path: "companyadminupdte",
          query: data
        });
      }
    },
    add() {
      this.$router.push({
        path: "/companyadminadd",
        query: { id: this.company_id }
      });
    },
    login(param) {
      let timestamp = new Date().getTime();
      var loginType="正式"
      if (sessionStorage.getItem("loginType")) {
          loginType = JSON.parse(sessionStorage.getItem("loginType"));
      }
var _url='www'
      if(loginType=="测试"){
_url='test'
      }
      let url =
        "https://"+_url+".migee.net/index.php/platform/company_admin/login" +
        "?id=" +
        param.id +
        "&company_id=" +
        this.company_id +
        "&device=PC" +
        "&timestamp=" +
        timestamp;
      console.log(url);
      window.open(url);
    },
    remove(index) {
      let self = this;
      this.$Modal.confirm({
        title: "管理员列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: index };
          deletecompany_admin(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    },
  changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.id)
      this.company_id = this.$route.query.id;
      this.company_name=this.$route.query.name
      this.mockTableData();
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/company/adminlist.vue